import "./SocialMedia.scss";
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

export const SocialMedia = () => {
	return (
		<div className="social-container">
			<InstagramIcon />
			<YouTubeIcon />
			<LinkedInIcon />
		</div>
	);
};